(function () {
  function starString(rating) {
    var full = Math.round(rating);
    var stars = '';
    for (var i = 0; i < 5; i++) {
      stars += i < full ? '★' : '☆';
    }
    return stars;
  }

  function buildCard(review, template) {
    var node = template.content.cloneNode(true);
    var card = node.querySelector('.review-card');
    card.querySelector('.review-card__stars').textContent = starString(review.rating);
    card.querySelector('.review-card__name').textContent = review.name;
    card.querySelector('.review-card__flag').textContent = review.flag || '';
    card.querySelector('.review-card__text').textContent = review.text;
    card.querySelector('.review-card__country').textContent = review.country || '';
    card.querySelector('.review-card__date').textContent = review.date || '';

    var photosWrap = card.querySelector('.review-card__photos');
    if (review.photos && review.photos.length) {
      review.photos.forEach(function (src) {
        var img = document.createElement('img');
        img.src = src;
        img.loading = 'lazy';
        img.alt = 'Photo shared by ' + review.name;
        img.className = 'review-card__photo';
        photosWrap.appendChild(img);
      });
    } else {
      photosWrap.remove();
    }

    return card;
  }

  function init(grid) {
    var url = grid.dataset.reviewsUrl;
    var displayCount = parseInt(grid.dataset.displayCount, 10) || 60;
    var sectionId = grid.id.replace('MiswakReviewsGrid-', '');
    var template = document.getElementById('MiswakReviewCardTemplate-' + sectionId);
    if (!url || !template) return;

    fetch(url)
      .then(function (response) {
        if (!response.ok) throw new Error('Failed to load reviews');
        return response.json();
      })
      .then(function (reviews) {
        grid.innerHTML = '';
        var shown = reviews.slice(0, displayCount);
        shown.forEach(function (review) {
          grid.appendChild(buildCard(review, template));
        });

        var showMoreBtn = document.getElementById('MiswakReviewsShowMore-' + sectionId);
        if (showMoreBtn && reviews.length > displayCount) {
          showMoreBtn.addEventListener('click', function () {
            reviews.slice(displayCount).forEach(function (review) {
              grid.appendChild(buildCard(review, template));
            });
            showMoreBtn.remove();
          });
        } else if (showMoreBtn) {
          showMoreBtn.remove();
        }
      })
      .catch(function () {
        grid.innerHTML = '<p class="reviews-imported__loading">Reviews are temporarily unavailable.</p>';
      });
  }

  function boot() {
    document.querySelectorAll('.reviews-imported__grid[data-reviews-url]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
